import SummaryTransportationComponent from './summary-transportation-component';

export default SummaryTransportationComponent;
